import React from 'react'
import { Button, Empty, Typography } from 'antd'
import { SearchOutlined, MenuOutlined, CloseOutlined } from '@ant-design/icons'
import SuggestionItem from '../SuggestionItem'
import styles from './index.module.scss'

const { Text } = Typography

const SuggestionsDropdown = ({
  suggestedTemplates,
  maxVisibleSuggestions,
  onTemplateSelect,
  onViewAllTemplates,
  onClose,
  isUnifiedConversation,
}) => {
  const renderSuggestionItems = () => {
    if (suggestedTemplates.length === 0) {
      return (
        <div className={styles.noSuggestions}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No matching templates found"
            style={{ padding: '16px' }}
          />
        </div>
      )
    }

    return suggestedTemplates.map((template, index) => (
      <SuggestionItem
        key={template.id || index}
        template={template}
        index={index}
        onSelect={onTemplateSelect}
        isUnifiedConversation={isUnifiedConversation}
      />
    ))
  }

  return (
    <div className={styles.suggestionsDropdown}>
      <div className={styles.suggestionsHeader}>
        <SearchOutlined className={styles.searchIcon} />
        <Text className={styles.suggestionsTitle}>Suggested Pre-Approved Templates</Text>
        <CloseOutlined className={styles.suggestionsCloseIcon} onClick={onClose} />
      </div>

      <div
        className={styles.suggestionsList}
        style={{
          maxHeight: `${maxVisibleSuggestions * 74}px`,
        }}
      >
        {renderSuggestionItems()}
      </div>

      {onViewAllTemplates && (
        <div className={styles.viewAllContainer}>
          <Button
            type="link"
            icon={<MenuOutlined />}
            onClick={onViewAllTemplates}
            className={styles.viewAllButton}
          >
            View all templates
          </Button>
        </div>
      )}
    </div>
  )
}

export default SuggestionsDropdown
